<template>
  <aha-modal
    :title="$i18nPresenter.t('we_really_value_your_feedback')"
    classesModal="modal-cancel-process modal-cancel-feedback"
    @hide="handleCloseModal"
  >
    <div class="modal-content">
      <div class="img-presenter text-center pt-2 pb-6">
        <img
          class="inline-block"
          :src="require('@/assets/images/cancel-subscription/cancel-feedback.svg')"
          width="175"
          height="133"
          alt=""
        >
      </div>
      <div class="font-bold">
        {{ $i18nPresenter.t('comment_with_colon') }}
      </div>
      <aha-textarea
        class="form-control"
        v-model="textReasonCancelSub"
        :maxLength="500"
        :placeholder="$i18nPresenter.t('enter_your_comment')"
        @focus="handleFocusCommentBox"
      />
    </div>
    <div class="actions flex py-3 justify-end">
      <aha-antd-button
        v-aha-emit-action
        v-blur-on-click
        name="cancel-subscription-cancel"
        class="mr-4"
        :disabled="isCancelButtonDisabled"
        variant="secondary"
        :submitting="isCancelProcessing"
        is-loading-inline
        @click="handleCancelSubscription"
      >
        {{ $i18nPresenter.t('cancel_subscription') }}
      </aha-antd-button>
      <div v-if="!isAlreadyAcceptOffer">
        <aha-antd-button
          v-aha-emit-action
          v-blur-on-click
          name="cancel-subscription-get-offer"
          :submitting="isGetOfferProcessing"
          is-loading-inline
          @click="handleGetOffer"
        >
          {{ $i18nPresenter.t('stay_and_get_offer') }}
        </aha-antd-button>
      </div>
    </div>
  </aha-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import StripeApi from '@/api/stripe'
import Util from '@/util'
import CancelSubscriptionGetOfferMixin from '@/mixins/cancel-subscription/GetOfferMixin'
import {
  CANCEL_SUBSCRIPTION_EVENT,
  CANCEL_SUBSCRIPTION_STEPS,
} from '@/constant/cancelSubscription'

export default {
  mixins: [CancelSubscriptionGetOfferMixin],
  props: {
    isAlreadyAcceptOffer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCancelProcessing: false,
      textReasonCancelSub: '',
    }
  },
  computed: {
    ...mapState({
      isRemoveCardPurpose: (state) => state.isRemoveCardPurpose,
    }),
    isCancelButtonDisabled() {
      return this.isCancelProcessing || !this.textReasonCancelSub
    },
  },
  beforeDestroy() {
    this.textReasonCancelSub = ''
  },
  methods: {
    ...mapActions(['updateRemoveCardPurposeAction']),
    handleCloseModal() {
      this._emitTrackEvent('Close')
      this.$emit(CANCEL_SUBSCRIPTION_EVENT, CANCEL_SUBSCRIPTION_STEPS.END)
    },
    handleFocusCommentBox() {
      this._emitTrackEvent('Focus input')
    },
    async handleCancelSubscription() {
      this.isCancelProcessing = true
      this._emitTrackEvent('Cancel subscription', {
        reason: this.textReasonCancelSub,
      })

      try {
        if (this.isRemoveCardPurpose) {
          await this._handleRemoveCard()
        } else {
          await this._turnOffAutoRenew()
        }
      } catch (e) {
        Sentry.captureException(e)
        Util.showToastError(this.$i18nPresenter.t(
          'Something went wrong, please check your connection or contact us for support',
        ))
      } finally {
        this.isCancelProcessing = false
      }
    },
    async _handleRemoveCard() {
      const { body: { ref } } = await StripeApi.removeCards()
      const payload = {
        stop: true,
        ref,
        reason: this.textReasonCancelSub,
      }
      await this._turnOffAutoRenew(payload)
    },
    async _turnOffAutoRenew() {
      const res = await StripeApi.cancelSubscription({
        stop: true,
        reason: this.textReasonCancelSub,
      })
      const subscriptionEndDate = res.body && res.body.endDate
      this.$emit('updatePropData', {
        subscriptionEndDate,
      })
      this.$emit(CANCEL_SUBSCRIPTION_EVENT, CANCEL_SUBSCRIPTION_STEPS.CANCELLED)
    },
    async handleGetOffer() {
      this._emitTrackEvent('Stay and get offer')
      await this.getOffer()
    },
    _emitTrackEvent(action, customProps) {
      this.$emit('trackEvent', {
        eventAction: `Cancel subscription > Cancel and get feedback pop-up > ${action}`,
        customProps,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.img-presenter {
  img {
    max-width: 100%;
    height: auto;
    background-color: #E5E5E5;
  }
}

.disabled {
  pointer-events: none;
  cursor: default;
}
</style>
